const InfoWindow = ({ name }) => (
  <div className="select-a-store-search__store-info-window">
    <p>{name}</p>
  </div>
);

export default InfoWindow;
